import { StateCreator } from 'zustand'

const vehicleInitialId = undefined

export interface VehicleIdSlice {
  vehicleId?: string | null
  setVehicleId: (payload: string | null) => void
}

const createVehicleIdSlice: StateCreator<VehicleIdSlice> = (set) => ({
  vehicleId: vehicleInitialId,
  setVehicleId: (payload: any) => {
    set(() => ({
      vehicleId: payload,
    }))
  },
})

export default createVehicleIdSlice
